import React from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

// Define prop types for the component
interface InfoWithTooltipProps {
  tooltipText: string;
  sx?: object; // Accepting the sx prop
  isDisabled: boolean;
}

const InfoWithTooltip: React.FC<InfoWithTooltipProps> = ({
  tooltipText,
  sx,
  isDisabled,
}) => {
  if (isDisabled) return <></>;
  return (
    <Tooltip title={tooltipText} arrow>
      <IconButton sx={{ ml: 4 }}>
        <ReportProblemIcon sx={sx} />
      </IconButton>
    </Tooltip>
  );
};

export default InfoWithTooltip;
